import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { rutas } from './rutas';
import { ErrorDeApi } from '@/shared/api/problema';
import { Notificaciones } from '@/shared/ui/Notificaciones';
import { AnfitrionDeProceso } from '@/shared/ui/Procesando';
import { crearCacheDeMutacionesConEspera } from '@/shared/ui/espera';

const clienteDeConsultas = new QueryClient({
  mutationCache: crearCacheDeMutacionesConEspera(),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (intentos, error) => {
        if (error instanceof ErrorDeApi && error.status < 500) {
          return false;
        }
        return intentos < 2;
      },
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={clienteDeConsultas}>
      <RouterProvider router={rutas} />
      <AnfitrionDeProceso />
      <Notificaciones />
    </QueryClientProvider>
  );
}
